/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Object } from '../../models/object';
import { PaginatedAdminUsersResponseDto } from '../../models/paginated-admin-users-response-dto';

export interface AdminUsersControllerGetAllAdminUsers$Params {

/**
 * Page number (1-based)
 */
  page?: number;

/**
 * Number of items per page
 */
  limit?: number;

/**
 * Field to sort by
 */
  sortBy?: string;

/**
 * Sort order (asc or desc)
 */
  sortOrder?: Object;

/**
 * Search term for filtering results
 */
  search?: string;
}

export function adminUsersControllerGetAllAdminUsers(http: HttpClient, rootUrl: string, params?: AdminUsersControllerGetAllAdminUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedAdminUsersResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminUsersControllerGetAllAdminUsers.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedAdminUsersResponseDto>;
    })
  );
}

adminUsersControllerGetAllAdminUsers.PATH = '/admin/users';
